import { apiGetEngineerData } from '../api/api';
import { GetEngineerDataResponse } from './getEngineerDataResponseSchema';

class ClientDataService {
  getEngineerData(
    token: string,
  ): Promise<GetEngineerDataResponse> {
    return apiGetEngineerData(token);
  }
}

export const clientDataService = new ClientDataService();
